import { WIRCreatedSectionKey, WIRCreatedSections } from 'pages/WellGuardian/WIR/wir.constants';
import { WIR } from 'types/wellGuardian';

import { getWirCreatedSectionKey } from './getSectionData';

export const getWirCreatedSections = (wir: WIR | null, country: string) =>
  (wir &&
    Object.keys(WIRCreatedSections).map(item => ({
      label: WIRCreatedSections[item as WIRCreatedSectionKey],
      value: item,
      phase: getWirCreatedSectionKey(country),
    }))) ??
  [];
